import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Label, Form, FormGroup } from "reactstrap";
import {
  updateHouseEdgePercentage,
  getHouseEdgePercentage,
} from "../../reducers/adminReducers";
const RakeSettings = ({ role }) => {
  const result = useSelector((state) => state.admin);
  const { houseEdgeData } = result || {};
  const initialState = {
    upgrader: 0,
    roulette: 0,
    coinFlip: 0,
    jackpot: 0,
  };
  const [houseEdge, setHouseEdge] = useState(initialState);
  const dispatch = useDispatch();

  const handleChangeHouseEdge = (e) => {
    const { name, value } = e.target;
    setHouseEdge({ ...houseEdge, [name]: value });
  };

  const handleSubmitHouseEdge = (e) => {
    e.preventDefault();
    dispatch(updateHouseEdgePercentage(houseEdge));
  };

  useEffect(() => {
    dispatch(getHouseEdgePercentage());
  }, [dispatch]);

  useEffect(() => {
    if (houseEdgeData) {
      setHouseEdge({
        upgrader: houseEdgeData[0]?.upgrader || 0,
        coinFlip: houseEdgeData[0]?.coinFlip || 0,
        roulette: houseEdgeData[0]?.roulette || 0,
        jackpot: houseEdgeData[0]?.jackpot || 0,
      });
    }
  }, [houseEdgeData]);

  return (
    <>
      <Form
        className="needs-validation user-add"
        onSubmit={handleSubmitHouseEdge}>
        <FormGroup className="row justify-content-start mx-0">
          <div className="admin-input col-xl-5 col-md-7">
            <Label className="col-form-label pt-0">Upgrader</Label>
            <input
              className="form-control"
              placeholder="Upgrader HouseEdge Percentage"
              type="number"
              name="upgrader"
              value={houseEdge?.upgrader}
              onChange={handleChangeHouseEdge}
            />
          </div>
        </FormGroup>
        <FormGroup className="row justify-content-start mx-0">
          <div className="admin-input col-xl-5 col-md-7">
            <Label className="col-form-label pt-0">Roulette</Label>
            <input
              className="form-control"
              placeholder="Crash Percentage"
              type="number"
              name="roulette"
              value={houseEdge?.roulette}
              onChange={handleChangeHouseEdge}
            />
          </div>
        </FormGroup>
        <FormGroup className="row justify-content-start mx-0">
          <div className="admin-input col-xl-5 col-md-7">
            <Label className="col-form-label pt-0">Jackpot</Label>
            <input
              className="form-control"
              placeholder="Crash Percentage"
              type="number"
              name="jackpot"
              value={houseEdge?.jackpot}
              onChange={handleChangeHouseEdge}
            />
          </div>
        </FormGroup>
        <FormGroup className="row justify-content-start mx-0">
          <div className="admin-input col-xl-5 col-md-7">
            <Label className="col-form-label pt-0">CoinFlip</Label>
            <input
              className="form-control"
              placeholder="Crash Percentage"
              type="number"
              name="coinFlip"
              value={houseEdge?.coinFlip}
              onChange={handleChangeHouseEdge}
            />
          </div>
        </FormGroup>

        <div className="form-button d-flex justify-content-start pt-3">
          <Button type="submit" color="primary">
            Save
          </Button>
        </div>
      </Form>
    </>
  );
};

export default RakeSettings;
